"use client";

import { Moon, Sun } from "lucide-react";
import { motion } from "framer-motion";
import { useTheme } from "@/contexts/ThemeContext";
import { cn } from "@/lib/utils";

interface ThemeToggleProps {
  className?: string;
}

const ThemeToggle = ({ className }: ThemeToggleProps) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <motion.button
      onClick={toggleTheme}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className={cn(
        "relative w-12 h-6 rounded-full border transition-all duration-300",
        "bg-gradient-to-r from-[#1A1A1A] to-[#2A2A2A]",
        "border-[#333333] hover:border-[#FFB400]",
        "dark:bg-gradient-to-r dark:from-[#F8F9FA] dark:to-[#E8E9EA]",
        "dark:border-[#CCCCCC] dark:hover:border-[#FFB400]",
        className
      )}
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
    >
      <div className="absolute inset-0 flex items-center justify-between px-1">
        <Sun className="w-3 h-3 text-[#F8F9FA] dark:text-[#1A1A1A] transition-colors duration-300" />
        <Moon className="w-3 h-3 text-[#F8F9FA] dark:text-[#1A1A1A] transition-colors duration-300" />
      </div>
      
      <motion.div
        className={cn(
          "absolute top-0.5 w-5 h-5 rounded-full",
          "bg-gradient-to-br from-[#FFB400] to-[#FFA000]",
          "shadow-lg shadow-[#FFB400]/20"
        )}
        initial={false}
        animate={{
          x: theme === 'dark' ? 26 : 1,
        }}
        transition={{
          type: "spring",
          stiffness: 500,
          damping: 30,
        }}
      />
    </motion.button>
  );
};

export default ThemeToggle;